import FormattedMessage from 'I18n/components/FormattedMessage';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { View } from 'foundations-components/transitional/components/View';
import { useEffect, useRef, useState } from 'react';
import { useDetailsPageContext } from '../context/DetailsPageContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const NAVBAR_HEIGHT = 44;
const EMBED_HEADER_HEIGHT = 60;
const EMBED_TOP_PADDING = 32;
const BOTTOM_MARGIN = 12;
export function DetailsPage({
  leftColumn,
  rightColumn
}) {
  const {
    appContext,
    published,
    isEmbedded
  } = useDetailsPageContext();
  const isPreview = !published;
  const [leftColumnTopPosition, setLeftColumnTopPosition] = useState(0);
  const leftColumnRef = useRef(null);
  useEffect(() => {
    if (!leftColumnRef.current) return;
    const updatePosition = () => {
      var _leftColumnRef$curren;
      const windowHeight = window.innerHeight;
      const leftColumnHeight = ((_leftColumnRef$curren = leftColumnRef.current) === null || _leftColumnRef$curren === void 0 ? void 0 : _leftColumnRef$curren.getBoundingClientRect().height) || 0;
      let topMargin = 0;
      if (isEmbedded) {
        topMargin = EMBED_HEADER_HEIGHT + EMBED_TOP_PADDING;
      } else if (appContext !== 'public') {
        topMargin = NAVBAR_HEIGHT;
      }
      const heightDifference = windowHeight - leftColumnHeight - topMargin - BOTTOM_MARGIN;
      setLeftColumnTopPosition(heightDifference < 0 ? heightDifference : isEmbedded ? 0 : 24);
    };
    const resizeObserver = new ResizeObserver(updatePosition);
    resizeObserver.observe(leftColumnRef.current);
    return () => resizeObserver.disconnect();
  }, [appContext, isEmbedded]);
  const previewBanner = /*#__PURE__*/_jsx(Alert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.previewAlert.titleText"
    }),
    type: "warning",
    marginBlockEnd: "500",
    children: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "detailsPage.previewAlert.message"
    })
  });
  return /*#__PURE__*/_jsxs(View, {
    backgroundColor: "fill-surface-recessed",
    "data-test-id": "details-page",
    children: [isPreview && previewBanner, /*#__PURE__*/_jsxs(Grid, {
      columnGap: "0",
      paddingInline: "0",
      children: [/*#__PURE__*/_jsx(GridItem, {
        paddingInlineEnd: "300",
        size: {
          xs: 12,
          md: 4
        },
        marginBlockEnd: "500",
        children: /*#__PURE__*/_jsx("div", {
          ref: leftColumnRef,
          style: {
            position: 'sticky',
            top: `${leftColumnTopPosition}px`
          },
          children: leftColumn
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        paddingInlineStart: "300",
        size: {
          xs: 12,
          md: 8
        },
        children: rightColumn
      })]
    })]
  });
}